import React from 'react'
import Image from 'components/shared/Image'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const TriangleImage = ({ className, type, ...rest }) => {
  return (
    <Image
      className={cx(className, css.TriangleImage, type)}
      forcedRatio={1}
      {...rest}
    />
  )
}

TriangleImage.defaultProps = {
  type: 'top-right',
}

export default TriangleImage
